import { httpServiceClient, queryClient } from '@/infra/http'
import { NamingStrategy } from '@/infra/http/http-service-client/http-service-client-types'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import {
  UserEnrollmentContentInfoQuery,
  UserEnrollmentContentInfoResponse
} from './user-enrollment-content-info-service-types'
import { formatUserEnrollmentContentInfo } from './user-enrollment-content-info-service-utils'

const getUserContentUrl = () => makeApiUrl('/v2/user/content/product')

export const userEnrollmentContentInfoService = {
  async fetchQueryUserEnrollmentContentInfo(id: number, toEnrollment?: boolean) {
    const response = await queryClient.fetchQuery({
      queryKey: ['user-enrollment-content-info', id, toEnrollment],
      queryFn: () =>
        userEnrollmentContentInfoService.fetchUserEnrollmentContentInfo(id, { toEnrollment }),
      staleTime: 1000
    })

    return response
  },

  async fetchUserEnrollmentContentInfo(id: number, query: UserEnrollmentContentInfoQuery = {}) {
    const pathUrl = `${getUserContentUrl()}/${id}/enrollment`

    const response = await httpServiceClient<UserEnrollmentContentInfoResponse>({
      method: 'get',
      url: pathUrl,
      params: {
        toEnrollment: query.toEnrollment
      },
      paramsNamingStrategy: NamingStrategy.snakeCase
    })

    return formatUserEnrollmentContentInfo(response.body.data as UserEnrollmentContentInfoResponse)
  }
}
